import { ErrorMessage, Field, useFormikContext } from 'formik';
import { useState } from 'react';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import { FormLabel } from '../forms';

interface PasswordFieldProps {
  name: string;
  label: string;
  groupClassName?: string;
  required?: boolean;
}

export const PasswordField = ({
  name,
  label,
  groupClassName = 'mb-lg-3 mb-1',
  required
}: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false);
  const { touched, errors } = useFormikContext<Record<string, unknown>>();
  const isInvalid = Boolean(touched[name] && errors[name]);

  return (
    <Form.Group className={groupClassName} controlId={name}>
      <FormLabel required={required}>{label}</FormLabel>
      <InputGroup>
        <Field
          name={name}
          type={visible ? 'text' : 'password'}
          as={Form.Control}
          isInvalid={isInvalid}
          aria-required={required || undefined}
        />
        <InputGroup.Text
          style={{ cursor: 'pointer' }}
          className="text-primary"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          {visible ? (
            <IoEyeOffOutline style={{ fontSize: 20 }} />
          ) : (
            <IoEyeOutline style={{ fontSize: 20 }} />
          )}
        </InputGroup.Text>
      </InputGroup>
      <ErrorMessage name={name}>
        {(msg) => (
          <FormControl.Feedback type="invalid" className="d-block">
            {msg}
          </FormControl.Feedback>
        )}
      </ErrorMessage>
    </Form.Group>
  );
};
